import apiClient from '@u/apiClient'
import actionsElys from '@/store/modules/partner/actions.elys.js'
import actionsEnaos from '@/store/modules/partner/actions.enaos.js'
import actionsGuestSuite from '@/store/modules/partner/actions.guestsuite.js'

export default {
  ...actionsElys,
  ...actionsEnaos,
  ...actionsGuestSuite,
  // region fetch
  getCremagestAvaiability({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      apiClient
        .get('/partners/cremagest/availability')
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchEnaosPlacesByWikiCity({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`partner/enaos/places`, { params: payload })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  checkCredentialsEnaos({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`partner/enaos/check-credentials`, { params: payload })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getEnaosHumanResources({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`partner/enaos/human-resources`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getEnaosFunerariums({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`partner/enaos/funerariums`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
